export default __webpack_public_path__ + "465f13a8b7521f309e694f1c760a8a70.png";